import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToFetchSources = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: any,
): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/leo/all/sources/${filters?.type}s?page=${pageNumber}&size=${pageSize}&sort=totalCitations%2Cdesc`
    return deviceAxios.get<any>(url, data);
};

const tryToFetchSourcesStats = (type: 'domain' | 'url'): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/leo/all/sources/${type}/trends?topN=5&lastRuns=5`);
};

export const SourcesService = {
    tryToFetchSources,
    tryToFetchSourcesStats
};